import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store'
import ElementUI from "element-ui";
import navData from "../components/Layout/_nav";
Vue.use(VueRouter);
const EUIMsgBoxOption = {
    title: '警告',
    message: '無登入資訊',
    type: 'warning',
    confirmButtonText: '確定',
    closeOnPressEscape: false,
    showClose: false,
    closeOnClickModal: false
};
const processVendorLinkTo = (to, from) => {
    let qryParamGid = '';
    let qryParamOrderId = '';
    let qryParamQDFMNo = '';
    let reviewId ='';

    if (to.query && to.query.gid) {
        qryParamGid = to.query.gid;
    } else if (from.query && from.query.gid) {
        qryParamGid = from.query.gid;
    } else if (to.query && to.query.orderid) {
        qryParamOrderId = to.query.orderid;
    } else if (from.query && from.query.orderid) {
        qryParamOrderId = from.query.orderid;
    } else if (to.query && to.query.qdfmno) {   //  是否QDFM
        qryParamQDFMNo = to.query.qdfmno;
        reviewId = to.query.reviewId;
    } else if (from.query && from.query.qdfmno) {   //  是否QDFM
        qryParamQDFMNo = from.query.qdfmno;
        reviewId = from.query.reviewId;
    }
    if (qryParamGid) {
        sessionStorage.setItem('purchaseId', qryParamGid);
    }
    if (qryParamOrderId) {
        sessionStorage.setItem('orderId', qryParamOrderId);
    }
    if (qryParamQDFMNo) {
        let userInfo = store.getters['userInfo'];
        let userType = userInfo.userType;

        sessionStorage.setItem('QDFM_Key', qryParamQDFMNo);

        if(userType === 'Member') {     //  判斷是否供應商並判斷進入的狀態
            switch(reviewId) {
                case '3': {   //  廠商回覆中
                    sessionStorage.setItem('QDFM_Status' , 'reply');
                    break;
                }

                case '5': {   //  品質審核中
                    sessionStorage.setItem('QDFM_Status' , 'watch');
                    break;
                }

                case '7': {   //  退件
                    sessionStorage.setItem('QDFM_Status' , 'reply');
                    break;
                }

                case '9': {   //  結案
                    sessionStorage.setItem('QDFM_Status' , 'watch');
                    break;
                }
                    
                default: {
                    sessionStorage.setItem('QDFM_Status' , 'watch');
                    break;
                }
            }

        } else {
            switch(reviewId) {
                case '3': {   //  廠商回覆中
                    sessionStorage.setItem('QDFM_Status' , 'watch');
                    break;
                }

                case '5': {   //  品質審核中
                    sessionStorage.setItem('QDFM_Status' , 'review');
                    break;
                }

                case '7': {   //  退件
                    sessionStorage.setItem('QDFM_Status' , 'watch');
                    break;
                }

                case '9': {   //  結案
                    sessionStorage.setItem('QDFM_Status' , 'watch');
                    break;
                }
                    
                default: {
                    sessionStorage.setItem('QDFM_Status' , 'watch');
                    break;
                }
            }

        }
        
    }
};
const processDefaultUrl = (allowList) => {
    if (allowList && allowList.length > 0 && navData) {
        const menuItemName = allowList[0];
        if (navData && navData.length > 0) {
            const item = navData[0];
            let url = '';
            item._children.forEach(element => {
                if (url) return;
                if (element.keyStr === menuItemName) {
                    url = '/#' + element.to;
                } else if (element.keyStr === 'Quality') {
                    const childItems = element.items;
                    childItems.forEach(e2 => {
                        if (url) return;
                        if (e2.keyStr === menuItemName) {
                            url = '/#' + element.to;
                        }
                    });
                }
            });
            return url;
        }
    }
    return '';
};
const routerObj = new VueRouter({
    routes: [
        {
            path: '/',
            // component: Layout,
            component: () => import('@/components/Layout/LayoutPage.vue'),
            children: [
                {
                    path: '',
                    name: 'PurchaseSearchList',
                    component: () => import('@/components/Purchase/PurchaseSearchList/PurchaseSearchList.vue'),
                },
                {
                    path: 'purchaseedit',
                    name: 'PurchaseEdit',
                    component: () => import('@/components/Purchase/PurchaseEdit/PurchaseEdit.vue'),
                },
                {
                    path: 'rfqsearchlist',
                    name: 'RFQSearchList',
                    component: () => import('@/components/RFQ/RFQSearchList/RFQSearchList.vue'),
                },
                {
                    path: 'rfqedit',
                    name: 'RFQEdit',
                    component: () => import('@/components/RFQ/RFQEdit/RFQEdit.vue'),
                },
                {
                    path: 'supplier',
                    name: 'Supplier',
                    component: () => import('@/components/Supplier/Supplier.vue'),
                },
                {
                    path: 'ordersearch',
                    name: 'OrderSearch',
                    component: () => import('@/components/Order/OrderSearch/OrderSearch.vue'),
                },
                {
                    path: 'report',
                    name: 'Report',
                    component: () => import('@/components/Order/OrderSearch/Report.vue'),
                },
                {
                    path: 'manufacturer',
                    name: 'Manufacturer',
                    component: () => import('@/components/Manufacturer/Manufacturer.vue'),
                },
                {
                    path: 'changeorder',
                    name: 'ChangeOrder',
                    component: () => import('@/components/ChangeOrder/ChangeOrder.vue'),
                },
                {
                    path: 'changeorderinformation',
                    name: 'ChangeOrderInformation',
                    component: () => import('@/components/ChangeOrder/Information.vue'),
                },
                {
                    path: 'orderstatus',
                    name: 'OrderStatus',
                    component: () => import('@/components/OrderStatus/OrderStatus.vue'),
                },
                {
                    path: 'delivery',
                    name: 'Delivery',
                    component: () => import('@/components/Delivery/Delivery.vue'),
                },
                {
                    path: 'deliveryinformation',
                    name: 'DeliveryInformation',
                    component: () => import('@/components/Delivery/Information.vue'),
                },
                {
                    path: 'statement',
                    name: 'Statement',
                    component: () => import('@/components/Statement/Statement.vue'),
                },
                {
                    path: 'account',
                    name: 'Account',
                    component: () => import('@/components/Account/Account.vue'),
                },
                {
                    path: 'scheduleline',
                    name: 'ScheduleLine',
                    component: () => import('@/components/ScheduleLine/ScheduleLine.vue'),
                },
                {
                    path: 'plan_masterfile',
                    name: 'PlanMasterFile',
                    component: () => import('@/components/PlanMasterFile/PlanMasterFile.vue'),
                },
                {
                    path: 'plan_masterfile_information',
                    name: 'PlanMasterFile_Information',
                    component: () => import('@/components/PlanMasterFile/Information.vue'),
                },
                {
                    path: 'trialproduction',
                    name: 'TrialProduction',
                    component: () => import('@/components/TrialProduction/TrialProduction.vue'),
                },
                {
                    path: 'information',
                    name: 'Information',
                    component: () => import('@/components/TrialProduction/Information.vue'),
                },
                {
                    path: 'iteminformation',
                    name: 'ItemInformation',
                    component: () => import('@/components/TrialProduction/ItemInformation.vue'),
                },
                {
                    path: 'tentativepreparationreport',
                    name: 'TentativePreparationReport',
                    component: () => import('@/components/TentativePreparationReport/TentativePreparationReport.vue'),
                },
                {
                    path: '/tentativepreparationreportinformation',
                    name: 'TentativePreparationReportInformation',
                    //component: () => import('@/components/TentativePreparationReport/Information.vue'),
                    component: () => import('@/components/TrialProduction/Information.vue'),
                },
                {
                    path: 'coa',
                    name: 'COA',
                    component: () => import('@/components/COA/COA.vue'),
                },
                {
                    path: 'jqm',
                    name: 'JQM',
                    component: () => import('@/components/JQM/JQM.vue'),
                },
                {
                    path: 'jqminformation',
                    name: 'JQMInformation',
                    component: () => import('@/components/JQM/Information.vue'),
                },
                {
                    path: 'coainformation',
                    name: 'COAInformation',
                    component: () => import('@/components/COA/COAInformation.vue'),
                },
                {
                    path: 'generaltable',
                    name: 'GeneralTable',
                    component: () => import('@/components/GeneralTable/GeneralTable.vue'),
                },
                {
                    path: 'generaltable_information',
                    name: 'GeneralTableInformation',
                    component: () => import('@/components/GeneralTable/Information.vue'),
                },
                {
                    path: 'element',
                    name: 'Element',
                    component: () => import('@/components/Element/Element.vue'),
                },
                {
                    path: 'elementinformation',
                    name: 'ElementInformation',
                    component: () => import('@/components/Element/Information.vue'),
                },
                {
                    path: 'qbr',
                    name: 'QBR',
                    component: () => import('@/components/QBR/QBR.vue'),
                },
                {
                    path: 'syslogfile',
                    name: 'SysLogFile',
                    component: () => import('@/components/SysAdm/SysLogFile.vue'),
                },
                {
                    path: 'qdfmform',
                    name: 'QDFMForm',
                    component: () => import('@/components/QDFM/QDFM.vue'),
                },
                {
                    path: 'qdfmformdetail',
                    name: 'QDFMFormDetail',
                    component: () => import('@/components/QDFM/QDFM_Detail.vue'),
                },
                {
                    path: 'qfm',
                    name: 'QFM',
                    component: () => import('@/components/QFM/QFM.vue'),
                },
                {
                    path: 'qfmedit',
                    name: 'QFMedit',
                    component: () => import('@/components/QFM/QFMedit.vue'),
                    meta: { requiresAuth: true },
                    props: (route) => ({ formData: route.query })
                },
                {
                    path: 'checkscore',
                    name: 'CheckScore',
                    component: () => import('@/components/CheckScore/CheckScore.vue'),
                },
                {
                    path: 'requestsearchlist',
                    name: 'RequestSearchList',
                    component: () => import('@/components/Request/RequestSearchList/RequestSearchList.vue'),
                    meta: {             
                        requiresAuth: true,
                        keepAlive: true,
                    },
                },
                {
                    path: 'requestedit',
                    name: 'RequestEdit',
                    component: () => import('@/components/Request/RequestEdit/RequestEdit.vue'),
                    meta: { requiresAuth: true },
                    props: (route) => ({ formData: route.query })
                },
                {
                    path: 'suppliersearchlist',
                    name: 'SupplierSearchList',
                    component: () => import('@/components/Request/SupplierSearchList/SupplierSearchList.vue'),
                },
                {
                    path: 'supplieredit',
                    name: 'SupplierEdit',
                    component: () => import('@/components/Request/SupplierEdit/SupplierEdit.vue'),
                    meta: { requiresAuth: true },
                    props: (route) => ({ formData: route.query })
                },
            ],
        },
        {

            path: '/NonQualificationVendor',
            name: 'NonQualificationVendor',
            component: () => import('@/components/NonQualificationVendor/NonQualificationVendorEdit.vue'),

        },
        {

            path: '/NonQualificationVendorComplete',
            name: 'NonQualificationVendorComplete',
            component: () => import('@/components/NonQualificationVendor/NonQualificationVendorComplete.vue'),

        },
    ]
})

routerObj.beforeEach((to, from, next) => {
    if (to.name === "NonQualificationVendor") {

        if (to.query.guid) {

            sessionStorage.setItem('outerGuid', encodeURIComponent(to.query.guid));

            sessionStorage.setItem('outerIsNew', false);

            next();

        } else if (to.query.factoryid) {

            sessionStorage.setItem('outerFactoryid', encodeURIComponent(to.query.factoryid));

            sessionStorage.setItem('outerIsNew', true);

            console.log("factoryid1");

            next();

        } else {

            EUIMsgBoxOption.message = '無效網址';

            ElementUI.MessageBox(EUIMsgBoxOption);

        }
    }
    else if (to.name === "NonQualificationVendorComplete") {

        next();
    }
    else {
        const isLogin = store.getters['isLogin'];
        if (to.query && to.query.trialItemKeys && to.path && to.path.indexOf('iteminformation') > -1) {
            let trialItemKeys = to.query.trialItemKeys;
            trialItemKeys = trialItemKeys.replace(/_/g, '\t');
            trialItemKeys = decodeURIComponent(trialItemKeys);
            sessionStorage.setItem('trialItemKeys', trialItemKeys);
        }
        if (!isLogin) {
            //未登入狀態 
            let qryParamAccount = '';
            let qryParamReturnUrl = '';
            let qryParamCheckTime = '';
            if (to.query && to.query.r) {
                qryParamAccount = to.query.r;
                if (to.query.u) {
                    qryParamReturnUrl = decodeURIComponent(to.query.u);
                }
                qryParamCheckTime = to.query.p;
            } else if (from.query && from.query.r) {
                qryParamAccount = from.query.r;
                if (from.query.u) {
                    qryParamReturnUrl = decodeURIComponent(from.query.u);
                }
                qryParamCheckTime = from.query.p;
            }
            if (qryParamAccount) {
                const payload = { account: qryParamAccount, returnUrl: qryParamReturnUrl, checkTime: qryParamCheckTime }
                store.dispatch('login', payload).then(() => {
                    let userInfo = store.getters['userInfo'];
                    if (userInfo && userInfo.account) {
                        console.log('Account=' + userInfo.account);
                        let reloadUrl = '';
                        const paramReturnUrl = store.getters['returnUrl'];
                        if (paramReturnUrl) {
                            // if(paramReturnUrl.indexOf('?') == -1){//沒有參數
                            //     //location.href = paramReturnUrl;
                            //     location.replace(paramReturnUrl);
                            //     setTimeout(() => {
                            //         location.reload();
                            //     } ,1000);                            
                            // }else{
                            //     reloadUrl = paramReturnUrl;
                            // }
                            reloadUrl = paramReturnUrl;
                        } else {
                            let allowList = userInfo.allowRouterNameList;
                            if (!allowList) {
                                allowList = [];
                            }
                            let isEmp = (userInfo.userType === 'Employee');
                            if (isEmp) {
                                if (allowList.includes('PurchaseSearchList')) {
                                    reloadUrl = '/#/';
                                } else if (allowList.includes('PlanMasterFile')) {
                                    reloadUrl = '/#/plan_masterfile';
                                } else {
                                    reloadUrl = processDefaultUrl(allowList);
                                }
                            } else {
                                if ('-M' === userInfo.roleId) {
                                    reloadUrl = '/#/OrderSearch';
                                } else if ('-QM' === userInfo.roleId) {
                                    reloadUrl = '/#/TrialProduction';
                                } else {
                                    reloadUrl = processDefaultUrl(allowList);
                                }
                            }
                        }
                        if (reloadUrl) {
                            location.replace(reloadUrl);
                            //location.reload();
                            //延遲一段時間才 reload 避免觸發反覆載入
                            setTimeout(() => {
                                location.reload();
                            }, 1000);
                        }
                        return;
                    } else {
                        let redirectUrl = store.getters['redirectUrl'];
                        let loginStatusMessage = store.getters['loginStatusMessage'];
                        if (redirectUrl) {
                            if (loginStatusMessage) {
                                store.commit('set', ['loginStatusMessage', '']);
                            } else {
                                loginStatusMessage = '無登入資訊';
                            }
                            EUIMsgBoxOption.message = loginStatusMessage + '，將回預設畫面(' + redirectUrl + ')';
                            redirectUrl += '?RocRedirect=' + encodeURIComponent(location.href);
                        } else {
                            redirectUrl = 'about:blank';
                            if (loginStatusMessage) {
                                store.commit('set', ['loginStatusMessage', '']);
                            } else {
                                loginStatusMessage = '無登入資訊';
                            }
                            EUIMsgBoxOption.message = loginStatusMessage + '，將回預設畫面(' + redirectUrl + ')';
                        }
                        ElementUI.MessageBox(EUIMsgBoxOption).then(() => {
                            location.href = redirectUrl;
                        });
                    }

                });
            } else {
                store.dispatch('currentUser', {}).then(() => {
                    let userInfo = store.getters['userInfo'];
                    if (userInfo && userInfo.account) {
                        console.log('Account=' + userInfo.account);
                        //判斷目前帳戶與可允許的路徑
                        let userType = userInfo.userType;
                        if (userType === 'Employee' || userType === 'Member') {
                            const allowList = userInfo.allowRouterNameList;
                            if (allowList && allowList.includes(to.name)) {
                                processVendorLinkTo(to, from);
                                next();
                                return;
                            }
                        }
                        //--路徑必須取得身分資訊呼叫回傳後才會有
                        let redirectUrl = store.getters['redirectUrl'];
                        console.log('redirectUrl', redirectUrl);
                        if (redirectUrl) {
                            EUIMsgBoxOption.message = '目前身分無此存取此路徑之權限，將回預設畫面(' + redirectUrl + ')';
                            redirectUrl += '?RocRedirect=' + encodeURIComponent(location.href);
                        } else {
                            redirectUrl = 'about:blank';
                            EUIMsgBoxOption.message = '目前身分無此存取此路徑之權限，將回預設畫面(' + redirectUrl + ')';
                        }
                        ElementUI.MessageBox(EUIMsgBoxOption).then(() => {
                            location.href = redirectUrl;
                        });
                    } else {
                        //--路徑必須取得身分資訊呼叫回傳後才會有             
                        let redirectUrl = store.getters['redirectUrl'];
                        if (redirectUrl) {
                            EUIMsgBoxOption.message = '無登入資訊，將回預設畫面(' + redirectUrl + ')';
                            redirectUrl += '?RocRedirect=' + encodeURIComponent(location.href);
                        } else {
                            redirectUrl = 'about:blank';
                            EUIMsgBoxOption.message = '無登入資訊，將回預設畫面(' + redirectUrl + ')';
                        }
                        ElementUI.MessageBox(EUIMsgBoxOption).then(() => {
                            location.href = redirectUrl;
                        });
                    }

                });
            }
        } else {
            next();
        }
    }


})
export default routerObj
